/*******************************************************************************
 * Urgency Step Actions and Reducer
 */

import {
	ActionMap,
	FormContext_Action_Payload,
} from '@/components/forms/FormContext';
import { RepairFormState, StepMap } from '../../constants';

export const UrgencyStepActions = {
	UPDATE_URGENCY: 'UPDATE_URGENCY',
} as const;

export type UrgencyStepAction = keyof typeof UrgencyStepActions;

export interface UrgencyStepActionPayload
	extends FormContext_Action_Payload<StepMap> {
	[UrgencyStepActions.UPDATE_URGENCY]: string;
}

export type UrgencyStepActionMap =
	ActionMap<UrgencyStepActionPayload>[keyof ActionMap<UrgencyStepActionPayload>];

export const isUrgencyStepActionMap = (
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	action: any,
): action is UrgencyStepActionMap => action.type in UrgencyStepActions;

export const UrgencyStepReducer = (
	state: RepairFormState,
	action: UrgencyStepActionMap,
): RepairFormState => {
	switch (action.type) {
		case UrgencyStepActions.UPDATE_URGENCY:
			return {
				...state,
				urgency: action.payload,
			};
		default:
			return state;
	}
};

export const isValid = (state: RepairFormState): boolean => {
	const { urgency } = state;
	return !!urgency;
};
